
/* injects from baggage-loader */
require('./style.styl');

import React, {Children} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

export default class ButtonsGroup extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    align: PropTypes.oneOf(['left', 'right', 'center'])
  }

  static defailtProps = {
    align: 'left'
  }

  render() {
    const {className, align} = this.props
    const classNames = classnames('buttons-group', className, {
      [`is-${align}`]: true
    })

    return (
      <div className={classNames}>
        {Children.map(this.props.children, child =>
          <div className='buttons-group_button'>{child}</div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/ButtonsGroup/index.js